import React from "react";

const ManPower = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3606_5)">
      <rect x="4" y="4" width="24" height="24" rx="4" fill="#EDEEFF" />
    </g>
    <path
      d="M17.9033 21.6738C17.3348 21.939 16.6915 22.1011 16.0033 22.1011C15.3151 22.1011 14.6868 21.9537 14.1184 21.6738V22.1159C14.1184 22.2927 14.0586 22.4696 13.9688 22.6022C14.5971 22.8674 15.3002 23.0001 16.0182 23.0001C16.7363 23.0001 17.4394 22.8527 18.0677 22.6022C17.978 22.4696 17.9181 22.2927 17.9181 22.1159L17.9182 21.6738H17.9033Z"
      fill="#5F67E0"
    />
    <path
      d="M18.8164 14.3832C19.4747 14.9284 19.9833 15.6504 20.2227 16.4756C20.4022 16.4167 20.6116 16.3872 20.8061 16.3872C20.9258 16.3872 21.0455 16.4019 21.1652 16.4167C20.8361 15.1348 20.0132 14.0296 18.9212 13.3223V13.3665V13.9707C18.9211 14.1179 18.8911 14.2653 18.8164 14.3832L18.8164 14.3832Z"
      fill="#5F67E0"
    />
    <path
      d="M11.7621 16.4757C12.0164 15.6505 12.5101 14.9284 13.1684 14.3832C13.1086 14.2653 13.0636 14.1181 13.0636 13.9707V13.3665V13.3223C11.9716 14.0295 11.1487 15.1347 10.8047 16.4167C10.9244 16.402 11.0441 16.3872 11.1638 16.3872C11.3881 16.3872 11.5826 16.4166 11.7621 16.4756L11.7621 16.4757Z"
      fill="#5F67E0"
    />
    <path
      d="M17.3166 10.2968C17.3166 11.0129 16.7271 11.5934 16.0001 11.5934C15.2731 11.5934 14.6836 11.0129 14.6836 10.2968C14.6836 9.58053 15.2731 9 16.0001 9C16.7271 9 17.3166 9.58053 17.3166 10.2968Z"
      fill="#5F67E0"
    />
    <path
      d="M13.9542 14.1132H18.0383C18.1131 14.1132 18.1729 14.0543 18.1729 13.9806V13.3764C18.1729 12.728 17.7391 12.168 17.1557 11.9766C16.8265 12.1976 16.4226 12.3302 15.9888 12.3302C15.555 12.3302 15.1511 12.1976 14.8219 11.9766C14.2236 12.1829 13.8047 12.7281 13.8047 13.3764V13.9806C13.8195 14.0542 13.8794 14.1132 13.9542 14.1132H13.9542Z"
      fill="#5F67E0"
    />
    <path
      d="M12.351 20.0859C12.0219 20.3069 11.6179 20.4543 11.1841 20.4543C10.7503 20.4543 10.3464 20.3217 10.0023 20.0859C9.41888 20.2922 9 20.8522 9 21.5006V22.1048C9 22.1785 9.05979 22.2374 9.13462 22.2374H13.2187C13.2935 22.2374 13.3533 22.1785 13.3533 22.1048V21.5006C13.3683 20.8374 12.9495 20.2922 12.351 20.0859H12.351Z"
      fill="#5F67E0"
    />
    <path
      d="M12.5002 18.4392C12.5002 19.1555 11.9108 19.736 11.1837 19.736C10.4567 19.736 9.86719 19.1555 9.86719 18.4392C9.86719 17.7231 10.4567 17.1426 11.1837 17.1426C11.9108 17.1426 12.5002 17.7231 12.5002 18.4392Z"
      fill="#5F67E0"
    />
    <path
      d="M21.9806 20.0859C21.6515 20.3217 21.2475 20.4543 20.8137 20.4543C20.3799 20.4543 19.976 20.3217 19.6468 20.0859C19.0634 20.2922 18.6445 20.8522 18.6445 21.5006V22.1048C18.6445 22.1785 18.7043 22.2374 18.7791 22.2374H22.8632C22.938 22.2374 22.9978 22.1785 22.9978 22.1048V21.5006C22.9978 20.8374 22.5789 20.2922 21.9806 20.0859H21.9806Z"
      fill="#5F67E0"
    />
    <path
      d="M22.133 18.4392C22.133 19.1555 21.5435 19.736 20.8165 19.736C20.0894 19.736 19.5 19.1555 19.5 18.4392C19.5 17.7231 20.0894 17.1426 20.8165 17.1426C21.5435 17.1426 22.133 17.7231 22.133 18.4392Z"
      fill="#5F67E0"
    />
    <path
      d="M16.7654 18.5254C16.7654 18.938 16.4214 19.2768 16.0025 19.2768C15.5836 19.2768 15.2396 18.938 15.2396 18.5254C15.2396 18.4812 15.2396 18.4222 15.2545 18.378H13.8633V18.7611C13.8633 18.8495 13.9231 18.9232 14.0129 18.9232L14.5515 18.9821C14.5664 18.9821 14.5814 18.9968 14.5964 19.0116C14.6113 19.0705 14.6412 19.1295 14.6712 19.1884C14.6861 19.2031 14.6712 19.2326 14.6712 19.2472L14.3271 19.6598C14.2673 19.7335 14.2823 19.8219 14.342 19.8808L14.6712 20.205C14.731 20.2639 14.8208 20.2639 14.8955 20.2197L15.3144 19.8808C15.3293 19.8661 15.3443 19.8661 15.3593 19.8808C15.4191 19.9103 15.479 19.9397 15.5388 19.9545C15.5537 19.9545 15.5687 19.9692 15.5687 19.9987L15.6136 20.5292C15.6285 20.6176 15.6884 20.6766 15.7781 20.6766H16.2419C16.3316 20.6766 16.4064 20.6177 16.4064 20.5292L16.4662 19.9987C16.4662 19.984 16.4812 19.9692 16.4962 19.9545C16.556 19.9398 16.6159 19.9103 16.6757 19.8808C16.6906 19.8661 16.7205 19.8661 16.7355 19.8808L17.1543 20.2197C17.2141 20.2786 17.3189 20.2639 17.3787 20.205L17.7078 19.8808C17.7676 19.8219 17.7676 19.7187 17.7227 19.6598L17.3488 19.2327C17.3339 19.218 17.3339 19.2032 17.3488 19.1738C17.3788 19.1149 17.3937 19.0559 17.4237 18.997C17.4386 18.9823 17.4536 18.9675 17.4685 18.9675L18.0071 18.9086C18.0968 18.8939 18.1567 18.8349 18.1567 18.7465V18.3634L16.7505 18.3633C16.7505 18.4222 16.7654 18.4811 16.7654 18.5254L16.7654 18.5254Z"
      fill="#5F67E0"
    />
    <path
      d="M17.9581 17.1221C17.8533 16.5179 17.4793 16.0169 16.9557 15.7369L16.866 16.4148C16.8511 16.5327 16.7463 16.6064 16.6416 16.6064H16.5968C16.4771 16.5917 16.4023 16.4738 16.4173 16.3559L16.537 15.4275C16.5519 15.3538 16.4921 15.2949 16.4173 15.2949H15.5645C15.4897 15.2949 15.4448 15.3686 15.4448 15.4275L15.5645 16.3559C15.5794 16.4738 15.5047 16.5917 15.385 16.6064H15.3402C15.2205 16.6064 15.1307 16.518 15.1158 16.4148L15.0261 15.7369C14.5024 16.0169 14.1284 16.5326 14.0237 17.1221C13.8292 17.1516 13.6797 17.3137 13.6797 17.52V17.6968C13.6797 17.7851 13.7545 17.8588 13.8443 17.8588H18.1378C18.2275 17.8588 18.3023 17.7851 18.3023 17.6968V17.52C18.3021 17.3137 18.1526 17.1516 17.9581 17.1221H17.9581Z"
      fill="#5F67E0"
    />
    <defs>
      <filter
        id="filter0_d_3606_5"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3606_5"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3606_5"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default ManPower;
